import { useEffect } from 'react';
import createFocusTrap from 'focus-trap';
import noop from '@atlaskit/ds-lib/noop';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
export var useFocusManager = function useFocusManager(_ref) {
  var initialFocusRef = _ref.initialFocusRef,
    popupRef = _ref.popupRef;
  useEffect(function () {
    if (!popupRef) {
      return noop;
    }
    var previouslyFocusedElement;
    var focusTrap;
    if (getBooleanFF('platform.design-system-team.remove-focus-trap-from-popup_3q7sk')) {
      previouslyFocusedElement = document.activeElement;
    } else {
      var trapConfig = {
        clickOutsideDeactivates: true,
        escapeDeactivates: true,
        initialFocus: initialFocusRef || popupRef,
        fallbackFocus: popupRef,
        returnFocusOnDeactivate: true
      };
      focusTrap = createFocusTrap(popupRef, trapConfig);
    }
    var frameId = null;

    // wait for the popup to reposition itself before we focus
    frameId = requestAnimationFrame(function () {
      frameId = null;
      if (getBooleanFF('platform.design-system-team.remove-focus-trap-from-popup_3q7sk')) {
        if (initialFocusRef && initialFocusRef.focus) {
          initialFocusRef.focus();
        } else {
          popupRef.focus();
        }
      } else {
        focusTrap.activate();
      }
    });
    return function () {
      if (frameId != null) {
        cancelAnimationFrame(frameId);
        frameId = null;
      }
      if (getBooleanFF('platform.design-system-team.remove-focus-trap-from-popup_3q7sk')) {
        if (previouslyFocusedElement && previouslyFocusedElement.focus) {
          previouslyFocusedElement.focus();
        }
      } else {
        focusTrap.deactivate();
      }
    };
  }, [popupRef, initialFocusRef]);
};